import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export class NADHowItWorks {
  private element: HTMLElement;
  private swiper: Swiper | null = null;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.initSwiper();
    this.initAnimations();
  }

  private initSwiper(): void {
    const swiperEl = this.element.querySelector<HTMLElement>('.nad-how-it-works__swiper');
    if (!swiperEl) return;

    this.swiper = new Swiper(swiperEl, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      // pagination: {
      //   el: swiperEl.querySelector<HTMLElement>('.nad-how-it-works__pagination'),
      //   clickable: true,
      // },
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
        1200: {
          spaceBetween: 24,
        },
      },
    });
  }

  private initAnimations(): void {
    const cards = this.element.querySelectorAll<HTMLElement>('.nad-how-it-works__card');
    if (cards.length === 0) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const card = entry.target as HTMLElement;
            const index = Array.from(cards).indexOf(card);
            setTimeout(() => {
              card.classList.add('animate-in');
            }, index * 150);
            this.observer?.unobserve(card);
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => this.observer!.observe(card));
  }

  public destroy(): void {
    this.swiper?.destroy(true, true);
    this.swiper = null;
    this.observer?.disconnect();
    this.observer = null;
  }

  static initializeAll(): void {
    document
      .querySelectorAll<HTMLElement>('.nad-how-it-works')
      .forEach((el) => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADHowItWorks(el);
        }
      });
  }
}
